































































import Vue, { PropType } from "vue";
import StripePrice from "@/lib/stripePrice";
import { UpdatepassPaymentConfirmProps } from "@/components/UpdatepassPaymentConfirm/UpdatepassPaymentConfirm.vue";

export interface UpdatepassPaymentInformationStripeInputForm {
  lang: any;
  locale: string;
  currencyCode: string;
  updatepassPlanCode: string;
  updatepassPrice: any;
  settlementScheduledAt: number;
  registerUrl: string;
  freeTrialType: any;
  prevUrl: string;
}
export default Vue.extend({
  name: "vc-updatepass-payment-information-stripe-input-form",
  data() {
    return {
      currency_code: this.currencyCode
    };
  },
  props: {
    lang: {
      type: Object as PropType<
        UpdatepassPaymentInformationStripeInputForm["lang"]
      >,
      default: () => {}
    },
    locale: {
      type: String as PropType<
        UpdatepassPaymentInformationStripeInputForm["locale"]
      >,
      default: ""
    },
    currencyCode: {
      type: String as PropType<
        UpdatepassPaymentInformationStripeInputForm["currencyCode"]
      >,
      default: ""
    },
    updatepassPlanCode: {
      type: String as PropType<
        UpdatepassPaymentConfirmProps["updatepassPlanCode"]
      >,
      default: ""
    },
    updatepassPrice: {
      type: String as PropType<
        UpdatepassPaymentInformationStripeInputForm["updatepassPrice"]
      >,
      default: ""
    },
    settlementScheduledAt: {
      type: Number as PropType<
        UpdatepassPaymentInformationStripeInputForm["settlementScheduledAt"]
      >,
      default: 0
    },
    registerUrl: {
      type: String as PropType<
        UpdatepassPaymentInformationStripeInputForm["registerUrl"]
      >,
      default: ""
    },
    freeTrialType: {
      type: String as PropType<UpdatepassPaymentConfirmProps["freeTrialType"]>,
      default: ""
    },
    prevUrl: {
      type: String as PropType<
        UpdatepassPaymentInformationStripeInputForm["prevUrl"]
      >,
      default: ""
    }
  },
  computed: {
    todayPrice(): any {
      let price = this.updatepassPrice;
      if (!(this.freeTrialType === null)) {
        price = 0;
      }
      return price;
    },
    yearlyPrice(): any {
      return this.updatepassPrice;
    },
    todayPricePaymentBtn(): any {
      let price = this.updatepassPrice;
      if (!(this.freeTrialType === null)) {
        price = 0;
      }
      return this.lang.payment_button.replace(
        ":price",
        StripePrice.getPrice(this.currencyCode, price)
      );
    }
  },
  watch: {}
});
